import { Shield, Award, Monitor, CalendarCheck } from "lucide-react";

const trustItems = [
  {
    icon: Shield,
    label: "Kostenfrei mit Pflegegrad",
    color: "text-cyan-700",
    bg: "bg-cyan-50",
  },
  {
    icon: Award,
    label: "Zertifiziert in NRW",
    color: "text-green-600",
    bg: "bg-green-50",
  },
  {
    icon: Monitor,
    label: "100% Digital",
    color: "text-cyan-700",
    bg: "bg-cyan-50",
  },
  {
    icon: CalendarCheck,
    label: "Schnelle Termine",
    color: "text-green-600",
    bg: "bg-green-50",
  },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="py-8 bg-white border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-8">
          {trustItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 justify-center p-3 rounded-xl hover:bg-slate-50/80 transition-colors"
              data-testid={`trust-item-${i}`}
            >
              <div className={`h-10 w-10 ${item.bg} rounded-xl flex items-center justify-center shrink-0`}>
                <item.icon className={`h-5 w-5 ${item.color}`} />
              </div>
              <span className="text-sm sm:text-base font-semibold text-slate-700">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
